import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'gl0003',
    ecrans: ['00-2'],
    
    params: ['id', '?ecjcleint', '?flgcop']
});

